import React, { useEffect, useState } from "react";

import { ReactComponent as CloseIcon } from "../../../assets/svg/close.svg";
import { ReactComponent as FilterIcon } from "../../../assets/svg/filter.svg";
import { Button } from "semantic-ui-react";
import "./ActivityFilters.scss";
import Scrollbars from "react-custom-scrollbars";
import FilterRefine from "../../MainContent/SMR/SMRFilters/FilterRefine";
import { useDispatch, useSelector } from "react-redux";
import { updateFilters } from "../../../actions/userActivityLogsAction";
import UsersFilters from "./UsersFilters";
import Duration from "../../MainContent/Dashboard/Filters/Duration";

const ActivityFilters = (props) => {
    const { setShowFilters } = props;
    const dispatch = useDispatch();

    const reducerFilterRefine = useSelector((state) => state.userActivityLogsReducer.filterRefineFilter);
    const reducerDuration = useSelector((state) => state.userActivityLogsReducer.filters);
    const companyUsers = useSelector((state) => state.userActivityLogsReducer.companyUsers || {});
    const userTimezone = useSelector((state) => state.globalReducer.company.user_timezone_name);

    const [filterRefineFilter, setRefineFilters] = useState(reducerFilterRefine || {});
    const [filters, setFilters] = useState(reducerDuration || {});

    useEffect(() => {
        setRefineFilters(reducerFilterRefine || {});
        setFilters(reducerDuration || {});
    }, [reducerDuration, reducerFilterRefine]);

    const applyFilters = () => {
        dispatch(updateFilters({ filterRefineFilter, filters }));
    };

    const getUserLists = () => {
        const users = [];
        Object.values(companyUsers)?.forEach((user) => {
            users.push({
                name: user.name,
                id: user.lite_id,
                is_active: user.is_active,
            });
        });
        return users;
    };

    return (
        <div className={`activity-filters-container skiptranslate`}>
            <div className="activity-filters-header">
                <span>
                    <FilterIcon />
                    Filters
                </span>
                <CloseIcon className="close-icon" onClick={() => setShowFilters(false)} />
            </div>
            <div className="filters-wrapper">
                <Scrollbars autoHide>
                    <UsersFilters userLists={getUserLists()} filterRefineFilter={filterRefineFilter} updateRefineFilter={setRefineFilters} />
                    <Duration filters={filters} updateFilters={setFilters} user_timezone_name={userTimezone} />
                    <FilterRefine
                        renderItems={["activityTypes"]}
                        userLists={Object.values(companyUsers)}
                        filterRefineFilter={filterRefineFilter}
                        updateRefineFilter={setRefineFilters}
                    />
                </Scrollbars>
            </div>
            <Button className="apply-filters" onClick={applyFilters}>
                Apply Filter
            </Button>
        </div>
    );
};

export default ActivityFilters;
